module.exports = __webpack_public_path__ + "static/images/cover_C12.2c3511d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C12.png
// module id = LCzZ
// module chunks = 8